/**
 * TrustGate Brand Title Component
 * 
 * Provides consistent gradient text styling for TrustGate branding
 * across all console pages and components.
 */

import React from 'react';

interface BrandTitleProps {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  onClick?: () => void;
}

export const BrandTitle: React.FC<BrandTitleProps> = ({ 
  children, 
  size = 'lg',
  className = "",
  onClick
}) => {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-xl', 
    lg: 'text-2xl',
    xl: 'text-5xl'
  };

  const baseClasses = `font-bold bg-gradient-to-r from-[#00d4aa] to-[#00a8cc] bg-clip-text text-transparent ${sizeClasses[size]}`;
  const combinedClasses = `${baseClasses} ${className}`;
  
  if (onClick) {
    return (
      <h1 className={combinedClasses} onClick={onClick} style={{ cursor: 'pointer' }}>
        {children}
      </h1>
    );
  }

  return (
    <h1 className={combinedClasses}>
      {children}
    </h1>
  );
};
